module.exports = __webpack_public_path__ + "static/media/anaAwardFuture-event.266be34c.webp";